var map = {
	"./browser-notice.de-CH.json": 1048,
	"./browser-notice.de-DE.json": 1049,
	"./browser-notice.en-CA.json": 1050,
	"./browser-notice.en-GB.json": 1051,
	"./browser-notice.en-IN.json": 1052,
	"./browser-notice.en-ME.json": 1053,
	"./browser-notice.en-US.json": 1054,
	"./browser-notice.es-EM.json": 1055,
	"./browser-notice.es-ES.json": 1056,
	"./browser-notice.fr-BE.json": 1057,
	"./browser-notice.fr-CA.json": 1058,
	"./browser-notice.fr-CH.json": 1059,
	"./browser-notice.nl-BE.json": 1060,
	"./browser-notice.nl-NL.json": 1061,
	"./browser-notice.pl-PL.json": 1062,
	"./browser-notice.pt-BR.json": 1063
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1047;